import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import {
  fetchGeneralpage,
  fetchHomepage,
  resetMessageContact,
  submitContactForm,
} from "../Redux/slice/homeSlice";
import { useDispatch, useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import { Icon } from "@iconify/react/dist/iconify.js";

const FooterRap = styled.div`
background: #fffcf9;
  .left-upper-footer h2 {
    font-size: 45px;
    font-weight: 600;
    color: #ffffff;
    line-height: 45px;
  }
  .cont-inpu {
    display: flex;
    gap: 15px;
    width: 100%;
    justify-content: space-between;
  }
  .dropdown-contain {
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }

  .dropdown-div {
    background: #ffffff;
    width: fit-content;
    height: fit-content;
    padding: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }
  .cancel-btn {
    width: 150px;
    height: 50px;
    background: #160009;
    color: #ffffff;
    border: none;
    border-radius: 100px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }
  .dropdown-div p {
    font-size: 20px;
    color: #34302f;
    font-weight: 500;
    max-width: 400px;
    text-align: center;
  }
  .left-upper-footer p {
    font-size: 16px;
    font-weight: 450;
    color: #ffffff;
  }
  .subscribe {
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    position: absolute;
    right: 10px;
    top: 8px;
    font-size: 14px;
    font-weight: 700;
    background: #34302f;
    height: 47px;
    width: 159px;
    border-radius: 100px;
    color: #ffffff;
  }
  .right-upper-footer input {
    border: 1px solid #ffffff;
    box-shadow: 0px 0px 30px 0px #00000014;
    background: #ffffff;
    width: 434px;
    height: 62px;
    padding: 20px;
    border-radius: 100px;
  }
  .right-upper-footer {
    position: relative;
  }

  .say-hello {
    box-shadow: 0px 0px 20px 0px #00000014;
    background: #ffffff;
    width: 211px;
    height: 65px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    color: #34302f;
    font-size: 20px;
    font-weight: 500;
    text-decoration: none;
  }
  .inner-footer-1 p {
    font-size: 24px;
    font-weight: 500;
  }
  .inner-footer-1 span {
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
  .inner-footer-1 {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }
  .sub-footer-1 img {
    width: 110px;
    height: 64px;
  }
  .sub-footer-1 p {
    color: #8f8d8c;
    font-size: 16px;
    font-weight: 450;
    max-width: 219px;
  }
  .sub-footer-2 h6 {
    color: #34302f;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 15px;
  }
  .sub-footer-2 p {
    color: #979594;
    font-size: 14px;
    font-weight: 450;
  }
  .email {
    color: #34302f !important;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
  .sub-footer-2,
  .helooooooo {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .helooooooo {
    gap: 10px;
  }
  .inner-footer-2 {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(5, 1fr);
  }
  .down-footer-text p {
    color: #979594;
    font-size: 12px;
    font-weight: 450;
   
  }
.down-footer-text {
 border-top: 1px solid #34302f1a;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
  .upper-footer {
    display: flex;
    gap: 10px;
    width: 100%;
    flex-direction: column;
    padding: 40px 50px;
    background: #121212;
    border-radius: 24px;
    
    justify-content: space-between;
  }
  .footer {
    background: #f7f7f7;
    display: flex;
padding: 20px;
    height: fit-content;
    flex-direction: column;
    justify-content: center;
  }


  .develop-1 p {
    max-width: 526px;
    text-align: center;
    line-height: 23px;
    font-weight: 600;
    color: #8f8d8c;

    font-size: 16px;
  }
  .develop-1 h2 {
    color: #34302f;
    font-size: 45px;
    font-weight: 600;
    line-height: 50px;
    max-width: 407px;
    text-align: center;
  }
  .orange-p {
    color: #e77817 !important;
  }
  .develop-1 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    align-items: center;
    margin: 100px 0px;
  }
  .contact-1 {
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .contact-1 img {
    width: 1200px;
  }
  .contact-info p {
    color: #8f8d8c;
    font-size: 18px;
    font-weight: 450;
  }
  .contact-info {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .contat-all-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-top: 50px;
  }
  .get-in {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .get-in p {
    color: #b8b8b8;

    font-size: 18px;
    font-weight: 400;
    max-width: 485px;
    text-align: center;
    line-height: 28px;
  }
  .get-in h4 {
    color: #ffffff;
    font-size: 50px;
    text-align: center;
    font-weight: 600;
  }
  .contact-icon {
    width: 40px !important;
    height: 40px !important;
    background: #ffffff3d;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .contact-info-new h4 {
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
  }
  .contact-info-new h6 {
    color: #b8b8b8;

    font-size: 16px;
    font-weight: 400;
  }
  .contact-info-new p {
    color: #ffffff;
    font-size: 16px;
    font-weight: 450;
    max-width: 293px;
  }
  .contact-info-new {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .contat-all-info-new {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .two-section-first {
     display: flex;
    flex-direction: column;
    gap: 60px;
  }
  .two-section-all {
     display: flex;
    gap: 15px;
  }
  .upper-footer-body {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    gap: 20px;
  }
  .upper-footer-left h2 {
    color: #ffffff;
  }
  .upper-footer-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .input-div input,  .input-div textarea {
    border: none;
    border: 1px solid #34302f1a;
border-radius: 10px;
    height: 44px;
    width: 455px;

  }
  .input-div textarea {
height: 134px;


  }
  .cont-inpu input {
    width: 211px !important;
  }
  .input-div label {
color: #34302f;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .input-div {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .submit-btn {
    background: #e77817;
    border: none;
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;

    border-radius: 10px;
  }
  .contact-mess-div {
    display: flex;
    flex-direction: column;
    gap: 30px;
    padding: 20px;
    border: 1px solid #34302f1a;
background: var(--Colors-Background-bg-secondary, #F9FAFB);
    border-radius: 12px;
    width: 499px;
  }
  .contact-2 {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    position: relative;
  }
  .down-footer-upper img {
    width: 54px;
    height: 32px;
  }
  .down-footer-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    margin-top: 30px;
  }
  .down-footer-upper-sub {
    display: flex;
    align-items: center;
    gap: 50px;
  }
  .nav-link {
    color: #51505A;
    font-weight: 600;
    font-size: 16px;
    text-decoration: none;

  }
    .down-footer {
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding-top: 0px;
  }
  .terms-link {
    color: #51505A;
    font-size: 16px;
    font-weight: 400;
text-decoration: none;
text-align: center;
  }
  .terms {
    display: flex;
    align-items: center;
    gap: 15px;
  }
    @media (max-width: 1024px) {
    .down-footer {
    }
    .inner-footer-2 {
      grid-template-columns: repeat(3, 1fr);
      gap: 80px;
    }
    .upper-footer-body {
      flex-wrap: wrap;
      gap: 60px;
    }
    .upper-footer {
      padding: 20px 10px;
    }
  }
  @media (max-width: 767px) {
    .upper-footer {
      flex-direction: column;
      gap: 20px;
    }
  }
  @media (max-width: 582px) {
    .down-footer {
    }
    .right-upper-footer input {
      width: 300px;
    }
    .subscribe {
      width: 130px;
    }
    .inner-footer-1 {
      flex-direction: column;
    }
    .inner-footer-1 p {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .inner-footer-2 {
      grid-template-columns: repeat(2, 1fr);
      gap: 80px;
    }
  }
  @media (max-width: 678px) {
    .contact-2 {
      flex-direction: column;
    }
    .contact-mess-div {
      margin-top: 20px !important;
    }
  }
  @media (max-width: 550px) {
    .contact-mess-div {
    }
    .two-section-all, .two-section-first, .upper-footer-body {
      gap: 30px;
    }
    .two-section-all {
      flex-direction: column !important;
    }
    .cont-inpu {
      flex-direction: column;
    }
    .cont-inpu input, .input-div input, .input-div textarea {
      width: 100% !important;
    }
    .down-footer-upper-sub {
      gap: 15px;
    }
    .down-footer-text {
      flex-wrap: wrap;
      gap: 30px;
      align-items: center;
      justify-content: center;
    }
  }
  @media (max-width: 400px) {
     .down-footer-upper-sub {
      gap: 10px;
    }
  }
  @media (max-width: 350px) {
  }


  @media (max-width: 340px) {
    .inner-footer-2 {
      grid-template-columns: repeat(1, 1fr);
      gap: 50px;
    }
  }
`;

const Footer = () => {
  const dispatch = useDispatch();
    const [clicked, setClicked] = useState(false);
    const [activeLink, setActiveLink] = useState("home");
  
  const {
    generalObject,
    submitloading,
    homeObject,
    loading,
    error,
    errorContactMessage,
    successContact,
  } = useSelector((state) => state.content || []);
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    message: "",
  });
  console.log(homeObject);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(submitContactForm(form));
  };

  const websetting = generalObject?.data?.websetting;
  const newsletter = homeObject?.data?.newsletter;
  const footerTitle = homeObject?.data?.footerTitle;
  console.log(websetting);

  useEffect(() => {
    dispatch(fetchHomepage()); // Call API on component mount
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchGeneralpage()); // Call API on component mount
  }, [dispatch]);

  const handleRest = () => {
    dispatch(resetMessageContact());
    setForm({
      first_name: "",
      last_name: "",
      email: "",
      message: "",
    });
  };

    const handleLinkClick = (link) => {
       const section = document.getElementById(link);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
        console.log(link);
        
      }
      setClicked(prev => !prev);
    };
  
    const { pathname } = useLocation();
    useEffect(() => {
      setClicked(false); // Close menu when route changes
    }, [pathname]);
  return (
    <FooterRap>
      <div className=" footer">
        <div id="contact" className="upper-footer">
          <div className="upper-footer-head">
            <div className="get-in">
              <h4>Get in touch with us</h4>
              <p>
                Contact us today to discuss how we can assist you. Enter your
                message details below
              </p>
            </div>
          </div>
          <div className="upper-footer-body">
            <div className="upper-footer-left">
              <div className="two-section-all">
                <div className="two-section-first">
                  <div className="contat-all-info-new">
                    <div className="contact-icon">
                      <Icon
                        width="30px"
                        height="30px"
                        icon="ic:outline-email"
                        style={{ color: "#ffffff" }}
                      />
                    </div>
                    <div className="contact-info-new">
                      <h4>Email:</h4>
                      <h6>Our friendly team is here to help.</h6>
                      <p>{websetting?.biz_email}</p>
                    </div>
                  </div>
                  <div className="contat-all-info-new">
                    <div className="contact-icon">
                      <Icon
                        width="30px"
                        height="30px"
                        icon="mingcute:phone-line"
                        style={{ color: "#ffffff" }}
                      />
                    </div>
                    <div className="contact-info-new">
                      <h4>Phone:</h4>
                      <h6>Mon-Fri from 8am to 5pm.</h6>
                      <p>{websetting?.biz_phone}</p>
                    </div>
                  </div>
                </div>
                <div className="contat-all-info-new">
                  <div className="contact-icon">
                    <Icon
                      width="30px"
                      height="30px"
                      icon="famicons:location-outline"
                      style={{ color: "#ffffff" }}
                    />
                  </div>
                  <div className="contact-info-new">
                    <h4>Office:</h4>
                    <h6>Come say hello at our office HQ.</h6>
                    <p>{websetting?.first_address}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-mess-div">
              <div className="input-div">
                <div className="cont-inpu">
                  <label>
                    First Name*
                    <input
                      type="text"
                      name="first_name"
                      value={form.first_name}
                      onChange={handleChange}
                      required
                    />
                  </label>
                  <label>
                    Last Name*
                    <input
                      type="text"
                      name="last_name"
                      value={form.last_name}
                      onChange={handleChange}
                      required
                    />
                  </label>
                </div>
                <label>
                  Email Address*
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </label>
                <label>
                  Message*
                  <textarea
                    
                    type="text"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    required
                  > </textarea> 
                </label>
                {errorContactMessage ? (
                  <p style={{ color: "red", textAlign: "center" }}>
                    {errorContactMessage}
                  </p>
                ) : (
                  ""
                )}
                <button
                  onClick={handleSubmit}
                  className="submit-btn"
                  disabled={submitloading}
                  style={{
                    opacity: submitloading ? 0.6 : 1,
                    cursor: submitloading ? "not-allowed" : "pointer",
                  }}
                >
                  {submitloading ? (
                    <ClipLoader color="white" size={35} />
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className=" containers down-footer">
          <div className="down-footer-upper">
                          <img src={`https://admin.abrigo-llc.com/${websetting?.favicon_url}`} alt="" />
                  <div className="down-footer-upper-sub">
                      <Link 
                                className={`nav-link ${activeLink === "home" ? "active" : ""}`}
                                to="/"
                                onClick={() => handleLinkClick("home")}
                              >
                                Home
                              </Link>
                              {/* <Link
                                className={`nav-link ${activeLink === "about" ? "active" : ""}`}
                                onClick={() => handleLinkClick("about")}
                              >
                                About Us
                              </Link> */}
                              <Link
                                className={`nav-link ${activeLink === "services" ? "active" : ""}`}
                                onClick={() => handleLinkClick("services")}
                              >
                                What we do
                              </Link>
                              <Link
                                className={`nav-link ${activeLink === "company" ? "active" : ""}`}
                                onClick={() => handleLinkClick("company")}
                              >
                                Projects
                              </Link>
                  </div>
          </div>
          <div className="down-footer-text">
          <p className="">
            © 2025 Abrigo LLC. All rights reserved.
          </p>
          <div className="terms">
            <Link className="terms-link">Terms</Link>
            <Link className="terms-link">Privacy</Link>
            <Link className="terms-link">Cookies</Link>
          </div>
          </div>
        </div>
      </div>
      {successContact ? (
        <div className="dropdown-contain">
          <div className="dropdown-div">
            <p>Thank you for contacting us! We will get back to you soon.</p>
            <button onClick={handleRest} className="cancel-btn">
              Close
            </button>
          </div>
        </div>
      ) : (
        ""
      )}
    </FooterRap>
  );
};

export default Footer;
